import styled, { css } from 'styled-components';

import { spacing } from '../../../../helpers/genericStyles';
import { ChevronDownOutlineIc } from '@dsch/dd-icons';

const ICON_WIDTH = '12px';
const GAP = 'S4';
const SIDE_PADDING = 'S4';

const Container = styled.div`
  ${spacing}
`;

const DatepickerContainer = styled.div(
  ({ theme }) => css`
    .react-datepicker {
      ${theme.fontSize.M14};
      width: 250px;
      background: ${theme.colors.WHITE};
      border: 1px solid ${theme.colors.GREY_LIGHT};
      border-radius: ${theme.borderRadius.default};
      overflow: hidden;

      &-popper {
        z-index: 1;
      }

      &__aria-live {
        position: absolute;
        clip-path: circle(0);
        border: 0;
        height: 1px;
        margin: -1px;
        overflow: hidden;
        padding: 0;
        width: 1px;
        white-space: nowrap;
      }
      &__header {
        padding: ${theme.spacing.M16};
        background: ${theme.colors.GREY_LIGHTER};
      }
      &__day-names {
        display: flex;
        justify-content: center;
        gap: ${theme.spacing.S8};
      }
      &__day-name {
        width: 24px;
        color: #333;
      }
      &__month {
        padding: ${theme.spacing.M16};
      }
      &__week {
        display: flex;
        justify-content: center;
        gap: ${theme.spacing.S8};
        margin-bottom: ${theme.spacing.S8};

        &:last-of-type {
          margin-bottom: 0;
        }
      }
      &__day {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 24px;
        height: 24px;
        color: ${theme.colors.GREY_DARKER};
        border-radius: ${theme.borderRadius.default};
        cursor: pointer;

        &:hover {
          background: ${theme.colors.GREY_LIGHTER};
        }
        &--today {
          font-weight: ${theme.fontWeight.bold};
        }
        &--selected {
          background: ${theme.colors.BLUE};
          color: ${theme.colors.WHITE};

          &:hover {
            background: ${theme.colors.BLUE_DARK};
          }
        }
        &--outside-month {
          visibility: hidden;
        }
      }
    }
  `,
);

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${({ theme }) => theme.spacing.M16};
`;

const SelectGroup = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing[GAP]};
`;

const SelectContainer = styled.div`
  position: relative;
`;

const Select = styled.select`
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  width: 100%;
  background: none;
  color: ${({ theme }) => theme.colors.GREY_DARKER};
  border: none;
  ${({ theme }) => theme.fontSize.M14}
  cursor: pointer;
  padding: ${({ theme }) =>
    `${theme.spacing[SIDE_PADDING]} calc(${theme.spacing[SIDE_PADDING]} + ${ICON_WIDTH}) ${theme.spacing[SIDE_PADDING]} ${theme.spacing.S4}`};
  appearance: none;
`;

const SelectIcon = styled(ChevronDownOutlineIc)`
  position: absolute;
  top: 50%;
  right: 2px;
  transform: translateY(-50%);
  pointer-events: none;
  color: ${({ theme }) => theme.colors.BLUE};
`;

const SelectedValue = styled.div`
  visibility: hidden;
  display: inline-block;
  // Equal to width of icon (12px), the gap between the text and the absolutely-positioned icon (4px), and the padding of the select element (4px)
  padding-right: ${({ theme }) =>
    `calc(${ICON_WIDTH} + ${theme.spacing[GAP]} + ${theme.spacing[SIDE_PADDING]}`});
`;

const SubtextContainer = styled.div`
  ${({ theme }) => theme.fontSize.S12};
  margin-top: ${({ theme }) => theme.spacing.S4};
  min-height: 16px;
`;

export {
  Container,
  DatepickerContainer,
  Header,
  SelectGroup,
  SelectContainer,
  Select,
  SelectIcon,
  SelectedValue,
  SubtextContainer,
};
